import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/analytics";

/**
 * Fires a `page_view` event to GTM / GA4 on every React Router navigation.
 *
 * Mount this inside <BrowserRouter>. A small delay (150ms) gives Helmet
 * time to update the document.title before we read it, so page_title in
 * GA4 matches the actual page (instead of the previous page's title).
 */
export default function GTMPageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search);
    }, 150);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
